import React from "react";
import styles from "./index.module.css";
import { Stack, Typography } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import BrandLogo from "../../assets/images/brand-logo.png";

export default function Nav() {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      className={styles.navBar}
      sx={{ justifyContent: "space-between" }}
    >
      <Stack
        sx={{ alignItems: "center", cursor: "pointer","& img": {width: { xs: "180px", sm: "auto" }} }}
        onClick={() => navigate("/")}
      >
        <img src={BrandLogo} alt="Brand Logo" />
      </Stack>
      <input type="checkbox" className="menu-btn" id="menu-btn" hidden></input>
      <label htmlFor="menu-btn" className="menu-icon">
        <span className="nav-icon"></span>
      </label>
      <ul className="navMenu">
        <li>
          <Typography component={NavLink} activeClassName="active-link" to="/about" variant="h6" sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            About Us
          </Typography>
        </li>
        <li>
          <Typography component={NavLink} activeClassName="active-link" to="/doctors" variant="h6" sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            Doctors
          </Typography>
        </li>
        {/* <li>
          <Typography variant="h6" sx={{ cursor: "pointer", fontFamily: 'Poppins', textDecoration: 'none', color: 'initial' }}>
            Services
          </Typography>
        </li> */}
        <li>
          <Typography component={NavLink} activeClassName="active-link" to="/services" variant="h6"  sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            Services
          </Typography>
        </li>
        <li>
          <Typography component={NavLink} activeClassName="active-link" to="/sustainability" variant="h6"  sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            Sustainability
          </Typography>
        </li>
        <li>
          <Typography component={NavLink} activeClassName="active-link" to="/onlinestore" variant="h6"  sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            Online Store
          </Typography>
        </li>
        <li>
          <Typography component={NavLink} activeClassName="active-link" variant="h6" to="/contact" sx={{ cursor: "pointer", textDecoration: 'none', color: 'initial' }}>
            Contact Us
          </Typography>
        </li>
      </ul>
    </Stack>
  );
}
